// Netlify Forms: submissions are stored in the Netlify dashboard and emailed to info@kalyaniconsultancy.com
// (Netlify → Forms → Form notifications). Netlify only knows a form if it finds it in a static HTML file at
// deploy time, so every form posted here must also exist in public/__forms.html with the same fields.
// We post to that static file, not "/", because the SPA rewrite in _redirects would swallow a POST to "/".
export const FORMS_ENDPOINT = '/__forms.html';

export const encodeForm = (formName, formData) => {
  const params = new URLSearchParams();
  params.append('form-name', formName);
  for (const [key, value] of formData.entries()) params.append(key, value);
  return params.toString();
};

export const submitNetlifyForm = async (formName, formEl) => {
  const res = await fetch(FORMS_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: encodeForm(formName, new FormData(formEl)),
  });
  if (!res.ok) throw new Error(`Form submission failed: ${res.status}`);
};
